import React from 'react'
import PHOTO_TYPES from '@constants/articles/photoTypes'
import ViewContent from '@components/html/editor/ViewEditorContent'
import BlogImage from '@components/blog/components/BlogImage'
import mix from '@utils/styles/mix'
import { postImages } from '@components/blog/utils/postLinks'

import styles from '@components/blog/styles/PostContent.module.css'
import postStyles from '@components/blog/styles/Post.module.css'
import imgStyles from '@components/blog/styles/ImageWrapper.module.css'

function Content ({ content }) {
    return (
        <section className={postStyles.container}>
            <ViewContent content={content} />
        </section>
    )
}

class PostContent extends React.PureComponent {

    render () {
        return (
            <section className={styles.content}>
                { this.renderTopContent() }
                { this.renderHorizontalPhoto() }
                { this.renderBottomContent() }
                { this.renderAdditionalPhotos() }
            </section>
        )
    }

    renderTopContent = () => {
        const { topContent } = this.props

        return Boolean(topContent)
            ? <Content content={topContent} />
            : null
    }

    renderHorizontalPhoto = () => {
        return this.horizontalPhotoExists()
            ? <section className={mix([styles.horizontal_photo, imgStyles.wrapper])}>
                <BlogImage src={this.horizontalPhotoSrc()} alt={this.props.title} />
              </section>

            : null
    }

    renderBottomContent = () => {
        const { bottomContent } = this.props

        return Boolean(bottomContent)
            ? <Content content={bottomContent} />
            : null
    }

    renderAdditionalPhotos = () => {
        const additionalPhotos = this.getAdditionalPhotos()
        return additionalPhotos.length
            ? <section className={mix([styles.additional_photos, styles.content])}>{ additionalPhotos }</section>

            : null
    }

    getAdditionalPhotos = () => {
        const { title, photosExist }  = this.props
        const additionalPhotos = []

        for (let i = PHOTO_TYPES.indexOf('photos'); photosExist.includes(i); ++i) {
            additionalPhotos.push(
                <div key={i} className={mix([imgStyles.wrapper, styles.additional_photo])}>
                    <BlogImage src={this.photoSrc(i)} alt={title} key={`p_${i}`} />
                </div>
            )
        }

        return additionalPhotos
    }

    horizontalPhotoExists = () => {
        const { photosExist } = this.props
        return photosExist.includes(PHOTO_TYPES.indexOf('horizontalPhoto'))
    }

    horizontalPhotoSrc = () => {
        return postImages(this.props.tracking.pid, 'horizontalPhoto')
    }

    photoSrc = (num) => {
        return postImages(this.props.tracking.pid, 'photos', num)
    }

}

export default PostContent